'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiShoppingBag = function TiShoppingBag(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.3 6.7h-16.6c-2.8 0-5 2.2-5 5v18.3c0 2.8 2.2 5 5 5h16.6c2.8 0 5-2.2 5-5v-18.3c0-2.8-2.2-5-5-5z m1.7 23.3c0 0.9-0.7 1.7-1.7 1.7h-16.6c-1 0-1.7-0.8-1.7-1.7v-12.1c0.5 0.3 1.1 0.4 1.7 0.4h2.5c0 3.3 2.6 5.9 5.8 5.9s5.8-2.6 5.8-5.9h2.5c0.6 0 1.2-0.1 1.7-0.4v12.1z m-14.2-11.7h8.4c0 2.3-1.9 4.2-4.2 4.2s-4.2-1.9-4.2-4.2z m14.2-3.3c0 0.9-0.7 1.7-1.7 1.7h-16.6c-1 0-1.7-0.8-1.7-1.7v-3.3c0-1 0.7-1.7 1.7-1.7h16.6c1 0 1.7 0.7 1.7 1.7v3.3z' })
        )
    );
};

exports.default = TiShoppingBag;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/shopping-bag.js
// module id = 3187
// module chunks = 0